import { Box } from '@mui/material';
import React from 'react';
import { Link } from 'react-router';

import logo from '@/assets/img/logo.png';
import { RouteEnum } from '@/models/route/Route.model.ts';

import { LogoStyles } from './logo.styles.ts';

export const Logo: React.FC = () => {
  return (
    <Box component={Link} sx={LogoStyles} to={RouteEnum.ROOT} viewTransition>
      <img alt="smallLogo" src={logo} style={{ height: '100%' }} />
    </Box>
  );
};
